import { useSelector } from 'react-redux';

import { CommonReduxState } from '@src/models/commons/reduxState.interface';
import { hasOrgWideAccess, resolveOrgAccess } from '../access';

/**
 * Whether the current user's organization role reaches every division, without
 * per-division membership.
 *
 * Reading the org access is not a single selector: when claims overflow, the org
 * entry is missing from the token and the org user doc carries the same role (see
 * ComponentBlocker). Callers that inline `claims.org[orgId]` silently lose that
 * fallback, so the resolution lives here.
 */
const useHasOrgWideAccess = (): boolean => {
  const orgId = useSelector((state: CommonReduxState) => state?.organizations?.organization?.id);
  const claims = useSelector((state: CommonReduxState) => state?.user?.access?.data?.claims);
  const orgUserAccess = useSelector(
    (state: CommonReduxState) => state?.user?.orgUser?.data?.access,
  );

  return hasOrgWideAccess(resolveOrgAccess(claims, orgId, orgUserAccess));
};

export default useHasOrgWideAccess;
